// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"339":"storefront","884":"admin"}[chunkId] || chunkId) + "." + {"73":"b1595858","339":"adce69dc","445":"b9d386a1","556":"6145ae55","884":"ee0db4bf"}[chunkId] + ".chunk.js";
};